<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "app",
}
</script>

<style src="@/assets/css/tailwind.css" />
<style>
body {
    margin: 0;
    padding: 0;
    font-family: 'Montserrat', sans-serif;
}
</style>